import { parseTime } from '@/utils/util'
import compuedFun from '../index'

const computedData = compuedFun()
const { showName } = computedData

export const form = {
  label_name: '', // 标签名
  initial_consonant: '', // 声母
  is_recommend: 0, // 推荐
  is_top: 0, // 置顶
  line_id: undefined, // 类目ID
  module: 1,
}

export const rules = {
  line_id: [ { required: true, message: '请选择发布平台', trigger: 'change' } ],
  label_name: [ { required: true, message: '请输入标签名称', trigger: 'change' } ]
}
